<template>
  <div class="a-tab__open">
    <div class="a-container-form u-margin-top-24">
      <div class="a-label">{{$t('form.lot.reduction-report.participants')}}:</div>
      <dropdown-new class="select-w-480"
                    :placeholder="'form.lot.reduction-report.all-participants'"
                    multiple
                    :options="availableParticipants"
                    v-model="filters.participants">
        <option value :label="'form.lot.reduction-report.select-all-participants'"></option>
      </dropdown-new>
    </div>
    <div class="a-container-form a-container-form--align-start u-padding-bottom-0">
      <div class="a-label">{{$t('form.lot.reduction-report.filter-bids')}}:</div>
      <div class="a-flex-start a-width-100-percent">
        <dropdown-new class="select-w-300 u-margin-right-20 u-margin-b-24"
                      :placeholder="'form.lot.reduction-report.filter-not-specified'"
                      v-model="filters.bidsFilter">
          <option value :label="'form.lot.reduction-report.filter-not-specified'"></option>
          <option value="more-than" :label="'form.lot.reduction-report.higher-price-than-recommended'"></option>
          <option value="less-than" :label="'form.lot.reduction-report.lower-price-than-recommended'"></option>
          <option value="equal-to" :label="'form.lot.reduction-report.price-equals-to-recommended'"></option>
          <option value="there-are-bids" :label="'form.lot.reduction-report.there-is-a-bid'"></option>
          <option value="there-are-no-bids" :label="'form.lot.reduction-report.there-is-no-bid'"></option>
          <option value="leader" :label="'form.lot.reduction-report.participant-is-leader'"></option>
        </dropdown-new>
        <template>
          <input-cost class="a-input a-input--w-120 u-margin-right-20 u-margin-b-24"
                      :placeholder="$t('form.lot.reduction-report.value')"
                      v-model="filters.threshold.value">
          </input-cost>
          <dropdown-new class="select-w-120 u-margin-b-24"
                        :placeholder="$t('form.lot.reduction-report.units')"
                        v-model="filters.threshold.unit">
            <option value :label="'form.lot.reduction-report.unit-not-specified'"></option>
            <option value="money" :label="'form.lot.reduction-report.money'"></option>
            <option value="percent">%</option>
          </dropdown-new>
        </template>
      </div>
    </div>
    <div class="a-container-form u-margin-top-0 u-padding-b-24">
      <div class="a-label">{{$t('form.lot.reduction-report.number-value')}}:</div>

      <div class="a-flex-start a-width-100-percent">
        <dropdown-new class="select-w-300 u-margin-right-20"
                      :placeholder="'form.lot.reduction-report.number-value-nature-not-specified'"
                      v-model="filters.valueFilter">
          <option value :label="'form.lot.reduction-report.number-value-nature-not-specified'"></option>
          <option value="count" :label="'form.lot.reduction-report.number-value-nature-quantity'"></option>
          <option value="total" :label="'form.lot.reduction-report.number-value-nature-sum'"></option>
          <option value="price" :label="'form.lot.reduction-report.number-value-nature-price'"></option>
        </dropdown-new>

        <div class="lot-search__advanced-attr-price" v-if="filters.valueFilter == 'count'">
          <label class="lot-search__advanced-against">
            {{$t('form.lot.reduction-report.number-value-from')}}:
            <input-number class="a-input a-input--w-100"
                          :placeholder="$t('form.lot.reduction-report.min')"
                          v-model="filters.interval.start"></input-number>
          </label>
          <label class="lot-search__advanced-until">
            {{$t('form.lot.reduction-report.number-value-to')}}:
            <input-number class="a-input a-input--w-100"
                          :placeholder="$t('form.lot.reduction-report.max')"
                          v-model="filters.interval.end"></input-number>
          </label>
        </div>

        <div class="lot-search__advanced-attr-price" v-else>
          <label class="lot-search__advanced-against">
            {{$t('form.lot.reduction-report.number-value-from')}}:
            <input-cost class="a-input a-input--w-100"
                        :placeholder="$t('form.lot.reduction-report.min')"
                        v-model="filters.interval.start"></input-cost>
          </label>
          <label class="lot-search__advanced-until">
            {{$t('form.lot.reduction-report.number-value-to')}}:
            <input-cost class="a-input a-input--w-100"
                        :placeholder="$t('form.lot.reduction-report.max')"
                        v-model="filters.interval.end"></input-cost>
          </label>
        </div>
      </div>
    </div>
    <div class="a-filter">
      <div class="a-filter__footer ">
        <button class="gui-btn gui-btn--white-border gui-btn--w-167"
                v-t="'buttons.reset-filters'"
                @click.prevent="onResetFilterClick">
        </button>

        <button class="gui-btn gui-btn--red gui-btn--w-140"
                v-t="'buttons.apply'"
                @click.prevent="onApplyFilterClick">
        </button>
      </div>
    </div>
    <div class="a-sort u-border-1px-top u-padding-top-24px" v-if="value">
      <p class="a-sort__see">
        {{$tc('form.lot.reduction-report.filter-result', value.specs.length)}}
      </p>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      },

      value: {
        type: Object
      }
    },

    data: () => ({
      filters: {
        active: undefined,
        participants: [],
        valueFilter: undefined,
        interval: {
          start: undefined,
          end: undefined
        },

        bidsFilter: undefined,
        threshold: {
          value: undefined,
          unit: undefined
        }
      }
    }),

    created() {
      this._prepareReport();
    },

    watch: {
      lot: {
        handler() {
          console.info('lot updated in filters')
          this._prepareReport();
        },
        deep: true
      },

      'filters.valueFilter'() {
        this.filters.interval.start = undefined;
        this.filters.interval.end = undefined;
      }
    },

    computed: {
      availableParticipants() {
        return _.uniqBy(this.bids.map(b => ({ id: b.request, name: b.participant })), 'id');
      },

      report() {
        let specs = this.lot.specs.map(e => ({
          position: e.position,
          name: e.catalog.name,
          count: _.toNumber(e.count),
          okei: e.okeiName,
          price: _.toNumber(e.price),
          total: _.toNumber(e.count) * _.toNumber(e.price),
          bestBid: _.get(this.bestBids, e.position),
          bids: this._prepareBidsForPosition(e.position),
          winner: e.winner
        }));

        if (this.filters.active) {
          specs = this._applyFilter(specs, this.filters.active);
        }

        return {
          specs,
          bids: this.bids,
          criteria: this.criteria,
          reductionCriteria: this.reductionCriteria
        }
      },

      bestBids() {
        return this.lot.specs.reduce((acc, e) => {
          acc[e.position] = this._findBestBid(e.position);
          return acc;
        }, {})
      },

      criteria() {
        return this.lot.criteria.expert.map(e => ({
          id: e.num,
          name: e.criterionName,
          weight: e.weight
        })) || [];
      },

      reductionCriteria() {
        return this.lot.criteria.reduction.map(e => ({
          id: e.num,
          name: e.criterionName,
          weight: e.weight
        })) || [];
      },

      bidsSummary() {
        const data = _.get(this.lot, 'requestsTotal.data', []);
        let requestData;

        const lotPriceCriteriaNums = this.lot.criteria.lotPrice.map(c => c.num);
        const expertCriteriaNums = this.lot.criteria.expert.map(c => c.num);
        const reductionCriteriaNums = this.lot.criteria.reduction.map(c => c.num);

        return _.get(this.lot, 'requestsTotal.summary', []).map(e => {
          if (_.get(requestData, 'request') !== e.requestId) {
            requestData = _.find(data, { request: e.requestId }) || {};
          }

          const priceLotCriteria = _.filter(requestData.criterions, d => d.bid === e.bid && d.position === e.position && _.includes(lotPriceCriteriaNums, d.num));
          const lotPrice = priceLotCriteria.reduce((acc, c) => acc + _.toFinite(c.value), 0);

          const expertCriteria = _.filter(requestData.criterions, d => {
            return d.bid === e.bid
                    && _.includes(expertCriteriaNums, d.num)
                    && (d.position === e.position || d.position === 0);
          });

          const reductionCriteria = _.filter(requestData.criterionsReduction, d => {
            return d.bid === e.bid
              && _.includes(reductionCriteriaNums, d.num)
              && (d.position === e.position || d.position === 0);
          });

          let criteria = expertCriteria.reduce((acc, e) => {
            acc[e.num] = {
              estimate: e.estimate
            };
            return acc;
          }, {});

          return {
            ...e,
            criteria,
            reductionCriteria: reductionCriteria.reduce((acc, e) => {
              acc[e.num] = {
                value: e.value,
                okei: e.okei
              };
              return acc;
            }, {}),
            participantPrice: lotPrice
          }
        })
      },

      bids() {
        return this.lot.requests.reduce((acc, req) => {
          if (req.state.APPROVED || req.state.CONDITIONALLY_APPROVED) {
            req.bids.filter(b => b.state.ACTIVE || b.state.ACCEPTED).map(b => {
              acc.push({
                participant: req.organization,
                request: req.num,
                id: b.id,
                num: b.num
              })
            })
          }
          return acc;
        }, []);
      }
    },

    methods: {
      _applyFilter(specs, filters) {
        const participants = _.get(filters, 'participants', []);
        const valueFilter = _.get(filters, 'valueFilter');
        const interval = {
          from:  _.get(filters, 'interval.start'),
          to:  _.get(filters, 'interval.end'),
        };
        const bidsFilter = _.get(filters, 'bidsFilter');
        const threshold = {
          value:  _.get(filters, 'threshold.value'),
          unit:  _.get(filters, 'threshold.unit'),
        };

        const hasBid = (b) => b.rank !== undefined;
        const hasNoBid = (b) => b.rank === undefined;

        const bidFilter = (bid) => {
          let passed = true;

          if (!_.isEmpty(participants)) {
            passed = passed && _.includes(participants, bid.request);
          }

          passed = passed && (bidsFilter === 'there-are-no-bids' ? hasNoBid(bid) : hasBid(bid));

          return passed;
        };

        const filter = (spec) => {
          let bids = spec.bids;

          if (valueFilter === 'count' && (interval.from || interval.to)) {
             const passed = (!interval.from || spec.count >= interval.from) && (!interval.to || spec.count <= interval.to);

             if (!passed) {
               return false;
             }
          }

          if (!_.isEmpty(participants)) {
            bids = _.filter(bids, bid => _.includes(participants, bid.request));
          }

          if (spec.price) {
            if (bidsFilter === 'more-than' && threshold.value) {
                const price = (threshold.unit === 'money' ? spec.price + threshold.value : spec.price + spec.price * threshold.value / 100);
                bids = _.filter(bids, bid => bid.participantPrice > price);
            }
            else if (bidsFilter === 'less-than' && threshold.value) {
              const price = (threshold.unit === 'money' ? spec.price - threshold.value : spec.price - spec.price * threshold.value / 100);
              bids = _.filter(bids, bid => bid.participantPrice < price);
            }
            else if (bidsFilter === 'equal-to') {
              bids = _.filter(bids, bid => bid.participantPrice == spec.price);
            }
          }

          if (bidsFilter === 'leader') {
            bids = _.filter(bids, bid => bid.isBest);
          }

          if (bidsFilter === 'there-are-no-bids') {
            bids = _.filter(bids, bid => hasNoBid(bid));
          }
          else {
            bids = _.filter(bids, bid => hasBid(bid));
          }

          if (valueFilter === 'price' && (interval.from || interval.to)) {
            bids = _.filter(bids, bid => {
              const price = bid.participantPrice;
              return (!interval.from || price >= interval.from)
                && (!interval.to || price <= interval.to);
            });
          }
          else if (valueFilter === 'total' && (interval.from || interval.to)) {
            bids = _.filter(bids, bid => {
              const price = bid.participantPrice;
              const total = spec.count * price;
              return (!interval.from || total >= interval.from) && (!interval.to || total <= interval.to);
            });
          }

          return bids.length > 0;
        };

        specs = specs.filter(s => filter(s));

        return specs;
      },

      _prepareReport() {
        this.$emit('input', this.report);
      },

      _findBestBid(position) {
        const bids = _.filter(this.bidsSummary, { position });
        const bestBid = _.maxBy(bids, 'estimate');

        return bestBid || {};
      },

      _prepareBidsForPosition(position) {
        const bids = _.filter(this.bidsSummary, { position });
        const orderedBids = _.orderBy(bids, 'estimate', 'desc');

        const minParticipantPrice = _.get(_.minBy(bids, 'participantPrice'), 'participantPrice');

        return this.bids.reduce((acc, b) => {
          const serial = _.findIndex(orderedBids, { bid: b.id });
          const info = {
            rank: serial > -1 ? serial + 1 : undefined,
            request: b.request,
            isBest: serial === 0,
            criteria: _.get(orderedBids[serial], 'criteria', {}),
            reductionCriteria: _.get(orderedBids[serial], 'reductionCriteria', {}),
            estimate: _.get(orderedBids[serial], 'estimate'),
            presentPriceEstimate: _.get(orderedBids[serial], 'presentPriceEstim'),
            presentPrice: _.get(orderedBids[serial], 'presentPrice'),
            participantPrice: _.get(orderedBids[serial], 'participantPrice'),
            minParticipantPrice: minParticipantPrice
          };

          acc[b.id] = info;
          return acc;
        }, {})
      },

      onApplyFilterClick() {
        this.filters.active = _.pick(this.filters, [
          'participants',
          'valueFilter',
          'interval',
          'bidsFilter',
          'threshold'
        ]);
        this._prepareReport();
      },

      onResetFilterClick() {
        this.filters =this.$options.data.apply(this).filters;
        this._prepareReport();
      }
    }
  }
</script>

<style scoped>

</style>
